import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { LoopServerCall, MetaTagHandler, ServerCallHandler, serverHtmlAttributes } from "../../library/client/serverCallHandler";
import NonLodable from "./nonLodable";
import NavBar from "./components/navbar";
import BeforeAfter from "./components/beforeAfter";
import StatsCard from "./components/statsCard";
import Services from "./components/services";
import Reviews from "./components/reviews";
import FAQ from "./components/faq";
import Contact from "./components/contact";
import Footer from "./components/footer";
import PageShell from "./components/pageShell";

const ContactUs = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Contact Us - Flyby Shine</title>
                        <meta name="description" content="Contact Flyby Shine today for a free quote. Schedule a consultation, call us, or email us. We are available 8am - 5pm CST (Mon - Sat)." />
                        <meta name="keywords" content="Contact Us, Flyby Shine, Free Quote, Schedule Consultation, Call Us, Email Us, 8am - 5pm CST, Mon - Sat" />
                        <meta property="og:image" content="/assets/videos/thumbnails/contact.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>
                <div className="short-hero">
                    <video autoPlay muted loop playsInline poster="/assets/videos/thumbnails/contact.png" >
                        <source src="/assets/videos/contact.mp4" type="video/mp4" />
                    </video>
                    <h1 data-aos="fade-up" data-aos-delay="100">Contact Us</h1>
                </div>




                <div >
                    <Contact />
                </div>

                <div className="duo-cards duo-wide">
                    <div className="duo-card depth-card" data-aos="fade-up" data-aos-delay="200">
                        <img src="/assets/mapIcon.png" alt="about" />
                        <h1>Our Location</h1>
                        <p style={{ maxWidth: 300 }}>490 Cherry Hill Drive, Madison, Mississippi 39110, United States</p>

                        <Link className="button-static" to={
                            'https://maps.app.goo.gl/64gE8RkGjyijUm6y9'
                        } target="_blank" style={{ marginTop: 20 }}>
                            Get Directions
                        </Link>
                    </div>
                    <div className="duo-card depth-card" data-aos="fade-up" data-aos-delay="300">

                        <h1>Social Media</h1>
                        <p>Follow Us on Socials</p>
                        <div className="social-strip">
                            <Link to={'https://www.facebook.com/share/qjiBNR4W9vvhFbPy/?mibextid=LQQJ4d'} target="_blank"><img src="/assets/facebook.png" alt="facebook" /></Link>
                            <Link to={'https://www.instagram.com/flyby_shine/'} target="_blank"><img src="/assets/instagram.png" alt="instagram" /></Link>
                            <Link to={'https://www.linkedin.com/company/contract-drone-service-exterior-cleaning-inspection-imaging/posts/?feedView=all'} target="_blank"><img src="/assets/linkedin.png" alt="linkedin" /></Link>
                            <Link to={'https://www.tiktok.com/@flyby_shine'} target="_blank"><img src="/assets/tiktok.png" alt="tiktok" /></Link>
                            <Link to={'https://www.youtube.com/channel/UChsxaZcJOzgqYNlke0zZiiw'} target="_blank"><img src="/assets/youtube.png" alt="youtube" /></Link>
                        </div>
                    </div>
                </div>




            </PageShell>

            <style>
                {
                    `
                    .contact-container {
                    margin: 0px; gap: 0px;margin-top: -70px}

                    .core-header {
                    display: none}
                    `
                }
            </style>

            {/* <MetaTagHandler >
                {() => (
                    <>
                        <title>Poodle</title>
                    </>
                )}
            </MetaTagHandler>  */}
            {/* <NonLodable /> */}

            {/* <h2><ServerCallHandler id={"getDogHusky"} pathway={'getDog'} data={{breed:'husky'}} fetchHandler={'/api'} overwrite={'getDogHusky.src'} /></h2> */}



        </>
    )
}

export default ContactUs